// Setup
import React from 'react'
import PropTypes from 'prop-types'

// Vendor
import cx from 'classnames'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Select from '@material-ui/core/Select'
import { withFormsy } from 'formsy-react'

// WeSpire
import TextFieldValidations from 'components/form/text_field_validations'

class ResultsSelect extends React.Component {
  constructor(props) {
    super(props)
    this.labelRef = React.createRef()
  }

  state = {
    labelWidth: 0,
  }

  componentDidMount() {
    const node = this.labelRef.current
    this.setState({
      labelWidth: node.offsetWidth + 3,
    })
  }

  handleChangeValue = (event) => {
    this.props.setValue(event.target.value)
    this.props.onChange && this.props.onChange(event.target.value)
  }

  render() {
    const {
      autoComplete,
      className,
      formControlProps,
      formHelperTextProps,
      inputLabelProps,
      name,
      optionProps,
      options,
      selectProps,
      value,
    } = this.props
    // As a controlled component, this should always have a default value.
    // If it starts as undefined, it will be switched from uncontrolled to
    // controlled as you type, which angers React. This also ensures the select
    // field label stays floated on blur when an option is selected.
    const { inputProps } = selectProps
    const inputClassName = inputProps && inputProps.className

    return (
      <TextFieldValidations {...this.props}>
        {(error, helperText, label, required) => (
          <FormControl
            {...formControlProps}
            className={cx('w-100', className)}
            data-test={name}
            error={error}
            variant="outlined"
          >
            <InputLabel
              {...inputLabelProps}
              htmlFor={name}
              id={`${name}-label`}
              ref={this.labelRef}
            >
              {label}
            </InputLabel>
            <Select
              {...selectProps}
              input={
                <OutlinedInput
                  className="w-100 fw-semi-bold"
                  id={name}
                  labelWidth={this.state.labelWidth}
                  name={name}
                  style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                />
              }
              inputProps={{
                ...selectProps.inputProps,
                'aria-required': required,
                autoComplete,
                className: cx('fs-2 h-100', inputClassName),
                'data-test': name,
                id: name,
              }}
              onChange={this.handleChangeValue}
              value={value}
            >
              {options.map((option) => (
                <MenuItem
                  {...optionProps}
                  key={option.label}
                  value={option.value || option.label}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText {...formHelperTextProps}>
              {helperText}
            </FormHelperText>
          </FormControl>
        )}
      </TextFieldValidations>
    )
  }
}

ResultsSelect.propTypes = {
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  formControlProps: PropTypes.object,
  formHelperTextProps: PropTypes.object,
  inputLabelProps: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  optionProps: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      value: PropTypes.any,
    }).isRequired
  ).isRequired,
  selectProps: PropTypes.shape({
    inputProps: PropTypes.shape({
      className: PropTypes.string,
    }),
  }),
  setValue: PropTypes.func.isRequired,
  textFieldProps: PropTypes.object,
  value: PropTypes.any,
}

ResultsSelect.defaultProps = {
  autoComplete: 'off',
  className: null,
  formControlProps: {},
  formHelperTextProps: {},
  inputLabelProps: {},
  onChange: null,
  optionProps: {},
  selectProps: {
    inputProps: {
      className: null,
    },
  },
  textFieldProps: {},
  value: '',
}

export const undecorated = ResultsSelect

export default withFormsy(ResultsSelect)
